import Button from "@mui/material/Button";
// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";
const CustomTabButton = styled(Button)(({ theme }) => ({
  minWidth: "170px",
  borderRadius: 0,
  textTransform: "none",
  fontWeight: "bold",
  fontSize: "0.875rem",
  fontFamily: "Proxima Nova, sans-serif",
  opacity: 1,
  color: "gray",
  background: "#f8f9f9",
  // "&.Mui-selected": {
  //   backgroundColor: "#c5d3e0ff",
  // },
  "&.MuiButton-root.Mui-selected": {
    background: "#1976d233",
    // borderLeft: "5px solid #00ccb1",
    color: "#000",
  },
}));

export default CustomTabButton;
